import React from 'react';
import {
  STAYCAST_BRANDING_KEYS,
  STAYCAST_PUBLIC_KEY_PATTERN,
} from '@sonifi/wb-admin/constants/wbAdminConstants';
import { isCustomStaycast } from '../../services/propertiesHelper';
import { capitalizeString } from '@sonifi/wb-core/utils/parseHelper';
import styles from '../../../styles/WbAdmin.module.css';

const Staycast = ({ errors, register, getValues, setValue }) => {
  // Prevent load Staycast if API data is not loaded
  if (!getValues('staycast')) {
    return <p className={styles.staycastError}>Staycast currently is not available</p>;
  }

  const selectedPreset = getValues('staycast.tokens');
  const parentPreset = getValues('staycast.customData.parent');
  const isCustom = isCustomStaycast({
    selectedPreset,
    parentPreset: getValues(`staycast.${parentPreset}`),
  });

  const checkPresetSelected = () => {
    const currentIsCustom = isCustomStaycast({
      selectedPreset,
      parentPreset: getValues(`staycast.${parentPreset}`),
    });
    const prt = currentIsCustom
      ? STAYCAST_BRANDING_KEYS.tokens
      : getValues('staycast.customData.parent');
    if (getValues('staycast.preset') !== 'tokens') {
      setValue('staycast.customData', {
        label: `Custom (${capitalizeString(getValues('staycast.preset'))})`,
        parent: getValues('staycast.preset'),
      });
    }

    setValue('staycast.preset', prt);
  };

  const getAppIcon = () => {
    if (typeof selectedPreset.appIcon === 'string') {
      return selectedPreset.appIcon;
    } else if (selectedPreset.appIcon) {
      return URL.createObjectURL(selectedPreset.appIcon);
    }
    return '';
  };

  return (
    <div className="branding_state">
      <div className="row">
        <section className="col-md-18 branding-staycast">
          <div>
            <select
              {...register('staycast.preset', {
                onChange: (e) => {
                  const val = e.target.value;
                  setValue('staycast.tokens', getValues(`staycast.${val}`));
                  setValue('staycast.customData', {
                    label: `Custom (${capitalizeString(val)})`,
                    parent: val,
                  });
                },
              })}
              className="form-control branding-cast-brand"
            >
              <option value={STAYCAST_BRANDING_KEYS.defaults}>
                Default Preset
              </option>
              <option value={STAYCAST_BRANDING_KEYS.hyatt}>Hyatt</option>
              <option value={STAYCAST_BRANDING_KEYS.marriott}>Marriot</option>
              <option
                value={STAYCAST_BRANDING_KEYS.tokens}
                style={{ display: isCustom ? 'block' : 'none' }}
              >
                {getValues('staycast.customData.label')}
              </option>
            </select>
          </div>
        </section>
      </div>

      <div className="row">
        <section className="branding col-md-4 col-md-offset-1">
          <div className="pull-left branding-app-icon">
            <label>App Icon</label>
            <div>
              <label htmlFor="appIconImage">
                {selectedPreset ? <img src={getAppIcon()} /> : null}
              </label>
              <small>
                Minimum:
                <br />
                40px by 40px
              </small>
              <div>
                <input
                  className="branding-subsection-header fileButton fileButton_large"
                  type="file"
                  id="appIconImage"
                  accept="image/jpeg, image/png"
                  onChange={(e) => {
                    setValue('staycast.tokens.appIcon', e.target.files[0]);
                    checkPresetSelected();
                  }}
                />
              </div>
            </div>
          </div>
        </section>
        <section className="branding col-md-13">
          <div>
            <label>App Name</label>
            <br />
            <input
              type="text"
              maxLength="23"
              {...register('staycast.tokens.appName', {
                onChange: checkPresetSelected,
              })}
            />
            <small>Maximum: 23 characters</small>
          </div>
          <div className="clearfix">
            <div className="pull-left">
              <label>Support Website</label>
              <br />
              <input
                type="text"
                maxLength="38"
                {...register('staycast.tokens.supportLink', {
                  onChange: checkPresetSelected,
                })}
              />
              <small>Recommended maximum: 38 characters</small>
            </div>

            <div className="pull-left">
              <label>Support Phone Number</label>
              <br />
              <input
                type="text"
                maxLength="17"
                {...register('staycast.tokens.supportPhone', {
                  onChange: checkPresetSelected,
                })}
              />
              <small>Maximum: 17 characters</small>
            </div>
          </div>
        </section>
        <section className="branding col-md-13 col-md-offset-5">
          <label>Pairing Public Key</label>
          <br />
          <textarea
            rows="10"
            cols="85"
            autoComplete="off"
            autoCorrect="off"
            autoCapitalize="off"
            spellCheck="false"
            className={
              errors?.staycast && errors.staycast?.key ? 'wb-invalid' : ''
            }
            {...register('staycast.key', {
              pattern: {
                value: STAYCAST_PUBLIC_KEY_PATTERN,
              },
            })}
          />
        </section>
      </div>
    </div>
  );
};

export default Staycast;
